import { Fragment } from 'react';

const lineBreaker = (str, asArray) => {
  const split = str.trim().split(/\r\n|\n|\\n/g);
  if (asArray) {
    return split.map((text, i) => (
      <Fragment key={i}>
        {text}
        {i < split.length - 1 && <br />}
      </Fragment>
    ));
  }

  return split.join('<br />');
};

export default lineBreaker;
